export const WORKFLOW_LABELS = {
  MISSING_REFUND: 'Refund never arrived',
  DUPLICATE_CHARGE: 'Duplicate charge',
  RENEWAL_RESCUE: 'Stop a renewal charge',
  TRIAL_EXPIRY: 'Trial about to convert',
  PRICE_INCREASE: 'Price increase',
  LATE_DELIVERY_CREDIT: 'Late delivery credit',
  BILLING_ERROR: 'Billing error',
  POST_CANCEL_CHARGE: 'Charged after canceling',
  OVERLAPPING_SUBSCRIPTION: 'Overlapping subscriptions',
  RETURN_WINDOW: 'Return window ending',
  WARRANTY_CLAIM: 'Warranty window ending',
};

export const STATE_LABELS = {
  DETECTED: 'Found',
  EVIDENCE_GATHERING: 'Reading your email',
  ELIGIBILITY_PENDING: 'Checking if you qualify',
  READY_FOR_REVIEW: 'Needs your OK',
  USER_NOTIFIED: 'Waiting for you',
  ACTION_SELECTED: 'Waiting for your decision',
  AWAITING_USER_DECISION: 'Waiting for your decision',
  AWAITING_APPROVAL: 'Waiting for your OK',
  APPROVED: 'Approved',
  EXECUTING: 'Sending the request',
  WAITING_FOR_MERCHANT: 'Waiting on the company',
  OUTCOME_VERIFICATION: 'Waiting for bank verification',
  WAITING_FOR_VERIFICATION: 'Waiting for bank verification',
  RESOLVED: 'Done',
};

export const REPLY_LABELS = {
  refund_reissued: 'Refund approved/reissued',
  confirmed: 'Refund approved/reissued',
  pending: 'Pending',
  needs_user_input: 'User input required',
  store_credit_offer: 'Offer requiring decision',
  denied: 'Denied',
  channel_change: 'Channel escalation',
  timeout: 'Timeout',
};

export const LEDGER_LABELS = {
  potential: 'Potential — found, no action yet',
  pending: 'Pending — you approved; waiting on the result',
  confirmed: 'Confirmed — merchant said they issued it',
  verified: 'Verified — bank activity confirms the money',
  recurring_verified: 'Verified annual recurring savings',
  rejected: 'Rejected — merchant denied the request',
  expired: 'Expired — deadline passed before action',
  dismissed: 'Dismissed — you decided not to pursue it',
};

export const OUTCOME_LABELS = {
  RECOVERED: 'Money recovered',
  AVOIDED: 'Charge avoided',
  CANCELED: 'Canceled',
  REJECTED: 'Company said no',
  EXPIRED: 'Deadline passed',
  USER_DISMISSED: 'You skipped this',
  OFFER_DECLINED: 'You declined that offer',
  STORE_CREDIT_ACCEPTED: 'Store credit accepted',
  RENEWAL_KEPT: 'You kept the plan',
  NEEDS_USER_INPUT: 'Company needs more from you',
};

export const FIELD_LABELS = {
  amount_cents: 'Amount',
  processing_window_days: 'Promised days',
  initiated_at: 'Refund started',
  order_number: 'Order number',
  merchant: 'Company',
  promised_by: 'Promised by',
  delivered_at: 'Delivered',
  current_price_cents: 'Current price',
  new_price_cents: 'New price',
  cadence: 'Billing cycle',
  shipping_cents: 'Shipping',
  claim_window_days: 'Claim window',
  renewal_at: 'Renews on',
  increase_percent: 'Increase',
  old_monthly_cents: 'Old monthly amount',
  new_monthly_cents: 'New monthly amount',
  billed_cents: 'Billed amount',
  charged_cents: 'Bank debit',
  return_window_end: 'Return by',
  warranty_until: 'Warranty ends',
  trial_ending: 'Trial ending',
  category: 'Service type',
};

export const AUDIT_LABELS = {
  'pipeline.run': 'Checked your documents',
  'case.approve': 'You approved a request',
  'case.send': 'Request sent',
  'case.execute': 'Request marked sent',
  'case.merchant_reply': 'Company reply recorded',
  'case.read': 'Opened a recovery',
  'ledger.confirmed': 'Company said the money is coming',
  'ledger.verified': 'Counted as money back',
};

export function workflowLabel(value) {
  if (!value) return '';
  return WORKFLOW_LABELS[value] || String(value).replaceAll('_', ' ').toLowerCase();
}

export function stateLabel(value) {
  if (!value) return '';
  return STATE_LABELS[value] || String(value).replaceAll('_', ' ').toLowerCase();
}

export function replyLabel(value) {
  if (!value) return '';
  return REPLY_LABELS[value] || String(value).replaceAll('_', ' ').toLowerCase();
}

export function ledgerLabel(value) {
  if (!value) return '';
  return LEDGER_LABELS[value] || String(value);
}

export function outcomeLabel(value) {
  if (!value) return '';
  return OUTCOME_LABELS[value] || String(value).replaceAll('_', ' ').toLowerCase();
}

export function fieldLabel(value) {
  if (!value) return '';
  return FIELD_LABELS[value] || String(value).replaceAll('_', ' ');
}

export function auditLabel(action) {
  if (!action) return '';
  return AUDIT_LABELS[action] || String(action).replaceAll('.', ' · ').replaceAll('_', ' ');
}

export function dollarsFromCents(cents) {
  return ((Number(cents) || 0) / 100).toFixed(2);
}
